import { createRouter, createWebHistory } from 'vue-router'
import AddDivision from '@/components/controls/AddDivisionControl.vue'
import AddDepartment from '@/components/controls/AddDeptControl.vue'
import AddSection from '@/components/controls/AddSectionControl.vue'
import AddPosition from '@/components/controls/AddPositionControl.vue'
import AddAdmin from '@/components/controls/AddAdmin.vue'
import AddAnc from '@/components/controls/AddAnnoucement.vue'
import AddNewsletter from '@/components/controls/AddNewsletter.vue'
import ConsiderationForm from '@/components/controls/FormSignatory/ConsiderationFormControl.vue'
import DashBoard from '../components/controls/DashboardPage.vue'
import HrrequestForm from '../components/controls/FormRequest/HrrequestFormControl.vue'
import MessageControl from '@/components/controls/MessageControl.vue'
import LeaveForm from '@/components/controls/FormSignatory/LeaveFormControl.vue'
import PsoSignatory from '@/components/controls/FormSignatory/PsoSignatoryControl.vue'
//import LeaveRequest from '@/components/controls/FormRequest/LeaveRequestControl.vue'
import TrainingForm from '@/components/controls/FormSignatory/TrainingRequistionControl.vue'
import Payroll from '@/components/controls/PayrollView.vue'
//import HrRequest from '@/components/controls/FormRequest/TrainingRequistion.vue'
import SearchEmployee from '@/components/controls/EmployeeProfile/SearchEditEmployeeView.vue'
import ConsiderationRequest from '@/components/controls/FormRequest/ConsiderationFormControl.vue'
import Overtime from '@/components/controls/FormRequest/OvertimeFormControl.vue'
import AddHrisAcc from '@/components/controls/AddHRISAcc.vue'
import Employee201View    from '@/components/controls/PersonnelServices/Employee201View.vue'
import EmployeeLeaveView  from '@/components/controls/PersonnelServices/EmployeeLeaveView.vue'
import JobDescriptionView from '@/components/controls/PersonnelServices/JobDescriptionView.vue'
import PoliciesProcedures from '@/components/controls/PoliciesProcedures/PoliciesProcedures.vue'
import FileMaintenance from '../components/controls/FormRequest/FileMaintenanceControl.vue'

import TrainingRequestFormView from '@/v1/view/form-request/TrainingRequestFormView.vue'
import LeaveTest from '@/v1/view/form-request/LeaveFormView.vue'
import ObFormView from '@/v1/view/form-request/ObFormView.vue'
// import TableControl from '@/components/controls/TableControl/TableControl.vue'
const routes = [
  {
    path: '/',
    name: 'dashboard',
    linkActiveClass: 'active',
    component: DashBoard,
    meta: {
        title: 'Dashboard',
        breadcrumb: [
          {
            label: 'Dashboard',
            path: '/dashboard'
          },
      ]
    }
  },
  {
    path: '/about',
    name: 'about',
    component: AddAdmin
  },
  {
    path: '/annoucement',
    name: 'annoucement',
    component: AddAnc
  },
  {
    path: '/newsletter',
    name: 'newsletter',
    component: AddNewsletter
  },
  {
    path: '/message',
    name: 'message',
    component: MessageControl
  },
  {
    path: '/division',
    name: 'division',
    component: AddDivision
  }
  ,
  {
    path: '/department',
    name: 'department',
    component: AddDepartment
  },
  {
    path: '/section',
    name: 'section',
    component: AddSection
  },
  {
    path: '/position',
    name: 'position',
    component: AddPosition
  },
  {
    path: '/leave-signatories',
    name: 'LeaveSignatories',
    component: LeaveForm
  },
  {
    path: '/pso-signatories',
    name: 'PSOSignatories',
    component: PsoSignatory
  },
  {
    path: '/training-requistion',
    name: 'Training Requistion',
    component: TrainingForm
  },
  {
    path: '/consideration-signatories',
    name: 'Consideration Signatories',
    component: ConsiderationForm
  }
  ,
  {
    path: '/leave-request',
    name: 'LeaveRequest',
    component: LeaveTest
  }
  ,
  {
    path: '/hr-request-form',
    name: 'HrrequestForm',
    component: HrrequestForm
  }
  ,
  {
    path: '/training-requistion-request',
    name: 'trainingrequistionrequest',
    component: TrainingRequestFormView
  },
  {
    path: '/payroll',
    name: 'payroll',
    component: Payroll
  },
  {
    path: '/search-employee',
    name: 'we',
    component: SearchEmployee
  },
  {
    path: '/consideration-Request',
    name: 'ConsiderationRequest',
    component: ConsiderationRequest
  },
  {
    path: '/employee-201',
    name: 'Employee 201',
    component: Employee201View
  },
  {
    path: '/employee-leave',
    name: 'Employee Leave Credit',
    component: EmployeeLeaveView
  },
  {
    path: '/job-description',
    name: 'Job Description',
    component: JobDescriptionView
  },
  {
    path: '/policies-procedures',
    name: 'Policies Procedures',
    component: PoliciesProcedures
  },
  {
    path: '/file-maintenance',
    name: 'File Maintenance',
    component: FileMaintenance
  },
  {
    path: '/hris-account',
    name: 'HRIS Account',
    component: AddHrisAcc
  },
  {
    path: '/overtime',
    name: 'Overtime',
    component: Overtime
  },
  {
    path: '/official-business',
    name: 'official-business',
    component: ObFormView
  },
  // {
  //   path: '/leave-testing',
  //   name: 'leave-testing',
  //   component: LeaveTest
  // }
]






TrainingForm
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
